module.exports = __webpack_public_path__ + "static/img/Moon.1c8a8ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet/Moon.svg
// module id = 1413
// module chunks = 0